import { useBrand, type MascotMood } from './brand';

/** The brand's character in the given mood, or nothing for a brand without one. */
export function BrandMascot({ mood, size = 96 }: { mood: MascotMood; size?: number }) {
  const Mascot = useBrand().mascot;
  if (!Mascot) return null;
  return (
    <span className="ui-mascot" data-mood={mood}>
      <Mascot mood={mood} size={size} />
    </span>
  );
}
